module.exports = __webpack_public_path__ + "img/54.11a3328c.png";